import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { content } from "@/content";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Approach } from "@/components/site/Approach";
import { About } from "@/components/site/About";
import { Experience } from "@/components/site/Experience";
import { Contact, Footer } from "@/components/site/Contact";

const detectInitialLang = () => {
  try {
    const langs =
      navigator.languages && navigator.languages.length
        ? navigator.languages
        : [navigator.language || navigator.userLanguage || "en"];
    return langs.some((l) => String(l).toLowerCase().startsWith("de")) ? "de" : "en";
  } catch (e) {
    return "de";
  }
};

function App() {
  const [lang, setLang] = useState(detectInitialLang);
  const t = content[lang];

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <div className="App min-h-screen bg-bone" data-testid="app-root">
      <Toaster position="bottom-right" theme="light" richColors />
      <Nav t={t} lang={lang} setLang={setLang} />
      <main>
        <Hero t={t} />
        <Marquee t={t} />
        <Services t={t} />
        <Approach t={t} />
        <About t={t} />
        <Experience t={t} />
        <Contact t={t} />
      </main>
      <Footer t={t} />
    </div>
  );
}

export default App;
